import React from 'react';
import { Link } from 'react-router-dom';
import { SplitReveal, Reveal } from '../motion';
import { CONTACT_EMAIL, CONTACT_MAILTO } from '../Header';

const NAV = [
    { label: 'Projeler', to: '/projeler' },
    { label: 'Hizmetler', to: '/#hizmetler' },
    { label: 'Süreç', to: '/#surec' },
    { label: 'Hakkımda', to: '/hakkimda' },
];

const APPS = [
    { label: 'Sumo AI', to: '/sonora-ai' },
    { label: 'Funo AI', to: '/funo' },
    { label: 'Tattoo AI', to: '/tattooai' },
    { label: 'Meriastro', to: '/meriastro' },
    { label: 'RevoAI', to: '/revoai' },
];

const SOCIAL = [
    { label: 'GitHub', href: 'https://github.com/thesammet' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/abd%C3%BC-samed-akg%C3%BCl-383906173/' },
];

const Underlined = ({ children }) => (
    <span className="border-b border-ink-300 pb-[2px] transition-colors duration-300 group-hover:border-ink">{children}</span>
);

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="bg-ink-50 text-ink" aria-label="Alt bilgi">
            <div className="container-site pt-[96px] pb-[48px] md:pt-[140px]">
                <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <SplitReveal as="h2" text="Konuşalım" className="t-display" />
                        <Reveal delay={0.1} className="mt-6 flex flex-col items-start gap-3 t-intro">
                            <a href={CONTACT_MAILTO} className="group">
                                <Underlined>{CONTACT_EMAIL}</Underlined>
                            </a>
                            <span className="text-ink-600">Ankara, Türkiye · uzaktan, dünyanın her yerine</span>
                        </Reveal>
                    </div>

                    <Reveal delay={0.15} className="lg:col-span-6 grid grid-cols-2 gap-8 md:grid-cols-3">
                        <ul className="space-y-3 text-[20px] font-medium">
                            {NAV.map((item) => (
                                <li key={item.label}>
                                    <Link to={item.to} className="group"><Underlined>{item.label}</Underlined></Link>
                                </li>
                            ))}
                            <li>
                                <a href={CONTACT_MAILTO} className="group"><Underlined>İletişim</Underlined></a>
                            </li>
                        </ul>
                        <ul className="space-y-3 text-[20px] font-medium">
                            {APPS.map((item) => (
                                <li key={item.label}>
                                    <Link to={item.to} className="group"><Underlined>{item.label}</Underlined></Link>
                                </li>
                            ))}
                        </ul>
                        <ul className="space-y-3 text-[20px] font-medium">
                            {SOCIAL.map((item) => (
                                <li key={item.label}>
                                    <a href={item.href} target="_blank" rel="noopener noreferrer" className="group">
                                        <Underlined>{item.label}</Underlined>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>

                <div className="mt-[96px] flex flex-col gap-4 border-t border-ink-100 pt-6 t-small text-ink-500 md:flex-row md:items-center md:justify-between">
                    <p>© 2019–{year} Abdü Samed Akgül · Fotoğraflar: Unsplash</p>
                    <ul className="flex flex-wrap gap-x-6 gap-y-2">
                        <li><Link to="/sonora-ai/privacy-policy" className="hover:text-ink">Sumo AI gizlilik</Link></li>
                        <li><Link to="/funo/privacy-policy" className="hover:text-ink">Funo AI gizlilik</Link></li>
                        <li><Link to="/tattooai/privacy-policy" className="hover:text-ink">Tattoo AI gizlilik</Link></li>
                        <li><Link to="/meriastro/privacy-policy" className="hover:text-ink">Meriastro gizlilik</Link></li>
                        <li><Link to="/revoai/privacy-policy" className="hover:text-ink">RevoAI gizlilik</Link></li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
